"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _sitecoreJssReact = require("@sitecore-jss/sitecore-jss-react");
var _reactBootstrap = require("react-bootstrap");
var _lodash = require("lodash");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 *  A react component to create Left or right column division on page
 *
 * @param {object} props The properties passed into the object
 *
 * @returns {React.ReactElement} Column Sub Layout
 */
function ColumnSubLayout(props) {
  var [_params, setParams] = (0, _react.useState)(new URLSearchParams(props.params.pageQuery));
  var [topicFilter, setTopicFilter] = (0, _react.useState)(Object.fromEntries([..._params]));
  var [items, setItems] = (0, _react.useState)([]);
  var sideColumnDirection = (0, _lodash.get)(props.rendering.params, 'ColumnDirection', 'right');
  var sideColumnSize = (0, _lodash.toSafeInteger)((0, _lodash.get)(props.rendering.params, 'SideColumnSize', '4'));
  var colSize = [12 - sideColumnSize, sideColumnSize];
  var placeholderKey = ['column-main-content', 'column-side-content'];
  if (sideColumnDirection === 'left') {
    colSize = [sideColumnSize, 12 - sideColumnSize];
    placeholderKey = ['column-side-content', 'column-main-content'];
  }
  (0, _react.useEffect)(() => {
    var qsTopics = !(0, _lodash.isEmpty)(topicFilter.category) && !(0, _lodash.isNil)(topicFilter.category) ? topicFilter.category.split('|') : [];
    setItems(qsTopics);
  }, [topicFilter]);
  var handleCheckbox = checkBx => {
    setTopicFilter({
      category: checkBx.join('|')
    });
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "app-container col-sub-layout"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    md: colSize[0]
  }, /*#__PURE__*/_react.default.createElement(_sitecoreJssReact.Placeholder, {
    name: placeholderKey[0],
    rendering: props.rendering,
    params: props.params,
    curTopics: items,
    handleCheckbox: handleCheckbox
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    md: colSize[1]
  }, /*#__PURE__*/_react.default.createElement(_sitecoreJssReact.Placeholder, {
    name: placeholderKey[1],
    rendering: props.rendering,
    params: props.params,
    topics: items
  }))));
}
var _default = exports.default = ColumnSubLayout;